import { Button } from "@material-ui/core";
import React from "react";
import Carregando from "../Pagina/Carregando";

const modal = (props) => (
	<div className={"modal fade-in " + (props.size ? "modal-" + props.size : "")}>
		{props.title && (
			<header className="modal__header">
				<h1>{props.title}</h1>
				{props.onCancel && props.onCancelTopo && (
					<Button
						variant="contained"
						onClick={props.onCancel}
						disabled={props.saving}
					>
						{props.onCancelLabel ? props.onCancelLabel : "Fechar"}
					</Button>
				)}
			</header>
		)}

		<section className="modal__content">
			<div className="p-1">
				{props.saving && <Carregando />}
				{props.children}
			</div>
		</section>
		<section className="modal__actions">
			<div className="p-1">
				{props.onConfirm && (
					<Button
						variant="contained"
						color="primary"
						className="mr-1"
						onClick={props.onConfirm}
						disabled={props.saving}
					>
						{props.onConfirmLabel ? props.onConfirmLabel : "Salvar"}
					</Button>
				)}
				{props.onCancel && !props.onCancelTopo && (
					<Button
						variant="contained"
						onClick={props.onCancel}
						disabled={props.saving}
					>
						{props.onCancelLabel ? props.onCancelLabel : "Fechar"}
					</Button>
				)}
			</div>
		</section>
	</div>
);

export default modal;
